export interface FAQItem {
  question: string;
  answer: string;
}

export const faqItems: FAQItem[] = [
  {
    question: "草莓视频调色和白平衡有什么关系？",
    answer: "白平衡是草莓视频调色的基础。如果白平衡不准确，草莓的红色会出现偏黄或偏蓝的情况，后续任何调色操作都无法完全弥补。正确的白平衡设置能够确保草莓呈现出最自然、最诱人的红色调，为后续的色彩增强打好基础。建议在拍摄时使用灰卡进行白平衡校准，或者在后期使用达芬奇的色温工具进行精细调整。",
  },
  {
    question: "草莓视频的饱和度应该设置为多少才合适？",
    answer: "草莓视频的理想饱和度没有绝对的数值，但一般来说，在矢量示波器上草莓红色的饱和度保持在65%-82%的区间最为合适。过高的饱和度会导致红色溢出、细节丢失；过低的饱和度则让草莓显得暗淡无光。建议在调色时始终开启矢量示波器，以数据为参考而不是仅凭肉眼判断。不同类型的草莓（如章姬、红颜）也有不同的饱和度特性，需要区别对待。",
  },
  {
    question: "手机拍摄的草莓视频可以做专业调色吗？",
    answer: "完全可以！现在的旗舰手机大多支持4K视频拍摄，部分型号甚至支持10-bit色彩深度和Log格式（如iPhone的Apple ProRes Log），这为后期调色提供了充足的空间。即使是不支持Log格式的手机，只要在拍摄时注意统一白平衡和曝光设置，后期仍然可以通过达芬奇、剪映等软件进行有效的色彩校正。手机拍摄的关键是前期控制好光线和曝光，后期调色只是锦上添花。",
  },
  {
    question: "草莓视频适合用暖色调还是冷色调？",
    answer: "这取决于你的内容定位和发布平台。暖色调（4500K-5000K）适合美食Vlog、烘焙教程等内容，给人温馨甜美的感觉，在抖音和小红书上效果很好。冷色调（5500K-6000K）适合商业广告和高端餐饮推广，显得清爽高级。中性偏暖（5000K-5500K）是最通用的选择，兼顾专业感和亲和力，适合B站和YouTube等平台。实际操作中建议拍摄时使用标准色温，在后期根据需求调整。",
  },
  {
    question: "拍草莓视频需要什么设备？",
    answer: "草莓视频拍摄的设备选择空间很大。入门级可以用手机配合自然光或一盏LED灯，就能拍出不错的效果。进阶级建议使用微单相机（如索尼ZV-E10）配合50mm或90mm微距镜头，以及两盏常亮灯加柔光箱。专业级则可以考虑全画幅机身配合专业微距镜头和多灯布光方案。记住：光线质量远比设备价格重要，一盏好的灯光比昂贵的机身更能提升画质。",
  },
  {
    question: "什么是色彩溢出？如何避免草莓红色溢出？",
    answer: "色彩溢出是指某个色彩通道的信号超过了显示设备或编码格式能够容纳的上限，导致该区域的细节完全丢失。草莓视频中最常见的是红色溢出，表现为草莓表面变成一片没有细节的纯红色块。避免方法是：1）始终开启波形示波器和矢量示波器监控色彩信号；2）饱和度调整不要过度，保持10%-15%的增幅即可；3）使用限定器单独调整红色区域时，注意观察示波器变化；4）在导出时选择支持更高色彩深度的编码格式（如10-bit HEVC）。",
  },
  {
    question: "草莓视频后期常用的软件有哪些？",
    answer: "常用的草莓视频后期软件分为几个层级：入门级推荐剪映专业版（免费且功能强大）和Adobe Premiere Rush；进阶级推荐Adobe Premiere Pro和Final Cut Pro，两者都内置了专业的色彩校正工具；专业级推荐DaVinci Resolve（达芬奇），它是行业标准的调色软件，免费版已经包含了绝大部分专业功能。对于草莓摄影后期，Lightroom和Photoshop是最佳搭档。建议从剪映开始，逐步过渡到达芬奇。",
  },
  {
    question: "草莓视频调色需要多长时间才能学会？",
    answer: "基础入门大约需要一周时间——理解色彩三要素（色相、饱和度、明度）、掌握白平衡调整、学会使用基本的调色工具。达到能独立完成专业级草莓视频调色的水平，通常需要2-3个月的持续练习。关键不在于时间长短，而在于是否有系统化的学习路径：先学理论（色彩学基础），再练技术（软件操作），最后培养审美（多看优秀作品）。建议每天至少练习30分钟的调色，坚持一个月就能看到明显进步。",
  },
];